export default "/assets/images/mila-square-new.dd213879e08f9a8e.png";